module.exports = __webpack_public_path__ + "static/media/card_icons.4ff92a54.png";